import type {
  CampaignReportRow,
  CreatorPerformanceRow,
} from '@/types/portal';
import { imageUrl } from '@/utils/assets';

/**
 * Reporting datasets for the /reports workspace. Campaign performance and
 * creator performance only — spend reporting has been retired from the UI.
 */
export const campaignReport: CampaignReportRow[] = [
  {
    id: 'cmp-glowrite-q4',
    name: 'GlowRite Skincare Q4 Push',
    brandClient: 'GlowRite',
    market: 'Kenya',
    markets: ['Kenya', 'Uganda'],
    currency: 'KES',
    budget: 1200000,
    spend: 742000,
    creators: 34,
    delivered: 96,
    totalDeliverables: 112,
    reach: 4180000,
    engagements: 313500,
    engagementRate: 7.5,
    status: 'Active',
  },
  {
    id: 'cmp-safipay-launch',
    name: 'SafiPay Fintech Launch',
    brandClient: 'SafiPay',
    market: 'Kenya',
    markets: ['Kenya', 'Uganda', 'Tanzania'],
    currency: 'KES',
    budget: 2400000,
    spend: 510000,
    creators: 52,
    delivered: 21,
    totalDeliverables: 96,
    reach: 1920000,
    engagements: 117000,
    engagementRate: 6.1,
    status: 'Recruiting',
  },
  {
    id: 'cmp-tusker-weekend',
    name: 'Tusker Lite Weekend Vibes',
    brandClient: 'Tusker Lite',
    market: 'Kenya',
    markets: ['Kenya'],
    currency: 'KES',
    budget: 900000,
    spend: 615000,
    creators: 22,
    delivered: 61,
    totalDeliverables: 66,
    reach: 5340000,
    engagements: 427000,
    engagementRate: 8.0,
    status: 'Active',
  },
  {
    id: 'cmp-ubuntu-cosmetics',
    name: 'Ubuntu Cosmetics Heritage',
    brandClient: 'Ubuntu Cosmetics',
    market: 'Tanzania',
    markets: ['Tanzania', 'Kenya'],
    currency: 'TZS',
    budget: 38000000,
    spend: 29800000,
    creators: 18,
    delivered: 44,
    totalDeliverables: 48,
    reach: 3210000,
    engagements: 196000,
    engagementRate: 6.1,
    status: 'Review',
  },
  {
    id: 'cmp-jua-health',
    name: 'Jua Health Awareness',
    brandClient: 'Jua Health',
    market: 'Kenya',
    markets: ['Kenya'],
    currency: 'KES',
    budget: 750000,
    spend: 690000,
    creators: 16,
    delivered: 47,
    totalDeliverables: 48,
    reach: 2680000,
    engagements: 174000,
    engagementRate: 6.5,
    status: 'Paying',
  },
  {
    id: 'cmp-farmfresh',
    name: 'FarmFresh Groceries Weekly',
    brandClient: 'FarmFresh',
    market: 'Kenya',
    markets: ['Kenya'],
    currency: 'KES',
    budget: 1500000,
    spend: 1120000,
    creators: 40,
    delivered: 184,
    totalDeliverables: 210,
    reach: 6120000,
    engagements: 502000,
    engagementRate: 8.2,
    status: 'Active',
  },
  {
    id: 'cmp-bongo-beats',
    name: 'Bongo Beats Festival',
    brandClient: 'Bongo Beats',
    market: 'Tanzania',
    markets: ['Tanzania'],
    currency: 'TZS',
    budget: 22000000,
    spend: 21850000,
    creators: 26,
    delivered: 78,
    totalDeliverables: 78,
    reach: 8940000,
    engagements: 608000,
    engagementRate: 6.8,
    status: 'Completed',
  },
  {
    id: 'cmp-mzuri-homes',
    name: 'Mzuri Homes Brand Reveal',
    brandClient: 'Mzuri Homes',
    market: 'DR Congo',
    markets: ['DR Congo'],
    currency: 'USD',
    budget: 28000,
    spend: 0,
    creators: 0,
    delivered: 0,
    totalDeliverables: 0,
    reach: 0,
    engagements: 0,
    engagementRate: 0,
    status: 'Discovery',
  },
];

export const creatorPerformance: CreatorPerformanceRow[] = [
  {
    id: 'cp-furaha',
    creatorId: 'crt-furaha',
    name: 'Furaha Salim',
    avatar: imageUrl('creators/crt-furaha.webp'),
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    platform: 'Instagram',
    tier: 'Nano',
    followers: 24900,
    engagementRate: 8.1,
    reach: 128000,
    deliverables: 8,
    onTimeRate: 97,
    paid: 96000,
    currency: 'KES',
    rating: 4.9,
    trend: 'up',
  },
  {
    id: 'cp-sanaa',
    creatorId: 'crt-sanaa',
    name: 'Sanaa Njeri',
    avatar: imageUrl('creators/crt-sanaa.webp'),
    campaign: 'FarmFresh Groceries Weekly',
    market: 'Kenya',
    platform: 'TikTok',
    tier: 'Micro',
    followers: 33800,
    engagementRate: 7.4,
    reach: 486000,
    deliverables: 9,
    onTimeRate: 96,
    paid: 126000,
    currency: 'KES',
    rating: 4.9,
    trend: 'up',
  },
  {
    id: 'cp-zawadi',
    creatorId: 'crt-zawadi',
    name: 'Zawadi Mwangi',
    avatar: imageUrl('creators/crt-zawadi.webp'),
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    platform: 'TikTok',
    tier: 'Mid',
    followers: 84300,
    engagementRate: 6.8,
    reach: 812000,
    deliverables: 6,
    onTimeRate: 92,
    paid: 192000,
    currency: 'KES',
    rating: 4.8,
    trend: 'up',
  },
  {
    id: 'cp-grace',
    creatorId: 'crt-grace',
    name: 'Grace Wambui',
    avatar: imageUrl('creators/crt-grace.webp'),
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    platform: 'Instagram',
    tier: 'Mid',
    followers: 72400,
    engagementRate: 5.0,
    reach: 312000,
    deliverables: 5,
    onTimeRate: 95,
    paid: 152000,
    currency: 'KES',
    rating: 4.8,
    trend: 'flat',
  },
  {
    id: 'cp-halima',
    creatorId: 'crt-halima',
    name: 'Halima Yusuf',
    avatar: imageUrl('creators/crt-halima.webp'),
    campaign: 'Ubuntu Cosmetics Heritage',
    market: 'Tanzania',
    platform: 'Instagram',
    tier: 'Macro',
    followers: 210000,
    engagementRate: 4.6,
    reach: 1240000,
    deliverables: 4,
    onTimeRate: 94,
    paid: 8400000,
    currency: 'TZS',
    rating: 4.7,
    trend: 'flat',
  },
  {
    id: 'cp-tunde',
    creatorId: 'crt-tunde',
    name: 'Tunde Bakari',
    avatar: imageUrl('creators/crt-tunde.webp'),
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Tanzania',
    platform: 'TikTok',
    tier: 'Macro',
    followers: 512000,
    engagementRate: 3.2,
    reach: 2140000,
    deliverables: 4,
    onTimeRate: 82,
    paid: 13600000,
    currency: 'TZS',
    rating: 4.3,
    trend: 'down',
  },
  {
    id: 'cp-brian',
    creatorId: 'crt-brian',
    name: 'Brian Otieno',
    avatar: imageUrl('creators/crt-brian.webp'),
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Kenya',
    platform: 'Instagram',
    tier: 'Micro',
    followers: 42100,
    engagementRate: 5.2,
    reach: 214000,
    deliverables: 6,
    onTimeRate: 89,
    paid: 149000,
    currency: 'KES',
    rating: 4.5,
    trend: 'down',
  },
  {
    id: 'cp-neema',
    creatorId: 'crt-neema',
    name: 'Neema Achieng',
    avatar: imageUrl('creators/crt-neema.webp'),
    campaign: 'SafiPay Fintech Launch',
    market: 'Kenya',
    platform: 'YouTube',
    tier: 'Macro',
    followers: 128000,
    engagementRate: 4.1,
    reach: 980000,
    deliverables: 2,
    onTimeRate: 88,
    paid: 130000,
    currency: 'KES',
    rating: 4.5,
    trend: 'flat',
  },
  {
    id: 'cp-david',
    creatorId: 'crt-david',
    name: 'David Mwansa',
    avatar: imageUrl('creators/crt-david.webp'),
    campaign: 'SafiPay Fintech Launch',
    market: 'Uganda',
    platform: 'Instagram',
    tier: 'Mid',
    followers: 61200,
    engagementRate: 5.5,
    reach: 286000,
    deliverables: 3,
    onTimeRate: 93,
    paid: 4200000,
    currency: 'UGX',
    rating: 4.7,
    trend: 'up',
  },
  {
    id: 'cp-emmanuel',
    creatorId: 'crt-emmanuel',
    name: 'Emmanuel Okello',
    avatar: imageUrl('creators/crt-emmanuel.webp'),
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Uganda',
    platform: 'TikTok',
    tier: 'Macro',
    followers: 340000,
    engagementRate: 3.9,
    reach: 1680000,
    deliverables: 3,
    onTimeRate: 85,
    paid: 8400000,
    currency: 'UGX',
    rating: 4.4,
    trend: 'flat',
  },
];

export const reportTabs = [
  { id: 'campaign', label: 'Campaign performance', icon: 'ri-megaphone-line' },
  { id: 'creator', label: 'Creator performance', icon: 'ri-user-star-line' },
];

export const reportPeriods = [
  { id: '3m', label: 'Last 3 months' },
  { id: '6m', label: 'Last 6 months' },
  { id: 'ytd', label: 'Year to date' },
];

export const reportInsights = {
  campaign: {
    title: 'Two campaigns are carrying most of the spend',
    body: 'GlowRite and FarmFresh account for 43% of spend this period and are pacing close to plan. Blended engagement sits above the 6% agency benchmark, driven mostly by micro-tier creators.',
    bullets: [
      'FarmFresh is 9% over plan with 88% of deliverables in',
      'Ubuntu Cosmetics is running 22% under budget at 92% delivered',
      'SafiPay has deployed only 21% of budget ahead of its launch window',
    ],
  },
  creator: {
    title: 'Micro creators are out-performing the cohort',
    body: 'Micro and nano creators average 7.6% engagement versus 4.1% for macro creators, at a fraction of the cost per reach. Delivery reliability holds above 90% across the cohort.',
    bullets: [
      'Furaha Salim leads the cohort on engagement at 8.1%',
      'Emmanuel Okello delivers the single largest reach',
      'Two creators sit below 85% on-time delivery and need a nudge',
    ],
  },
};

export const reportExports = [
  {
    id: 'ex-1',
    name: 'Q3 Campaign performance',
    format: 'PDF',
    period: 'Jul – Sep 2026',
    date: '12 Sep 2026',
    by: 'Peter Kironji',
  },
  {
    id: 'ex-2',
    name: 'August spend ledger',
    format: 'CSV',
    period: 'Aug 2026',
    date: '2 Sep 2026',
    by: 'Grace Kim',
  },
  {
    id: 'ex-3',
    name: 'Creator performance — Kenya',
    format: 'PDF',
    period: 'Year to date',
    date: '28 Aug 2026',
    by: 'Peter Kironji',
  },
];